import { useErrorApi } from "../../error/ErrorHooks"
import { ErrorType } from "../../error/ErrorType"
import { ValidationError } from "./ValidationError"
import { ValidationException } from "./ValidationException"

export const useErrorMessaging = () => {
  const errorApi = useErrorApi()

  const setErrorMessages = (validationError: ValidationError) => {
    Object.keys(validationError).map(key => {
      if (ErrorType[key]) {
        validationError[key].forEach(message => {
          errorApi.setError(ErrorType[key], message)
        })
      }
    })
  }

  const catchValidationException = (err: Error) => {
    if (err instanceof ValidationException) {
      setErrorMessages(err.validationError)
    } else {
      throw err
    }
  }

  return {
    catchValidationException,
    setErrorMessages
  }
}
